
import DataString from '../src/static/DataString.json'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import {createApp} from 'vue'
import moment from 'moment'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import { toolVersionVerify } from './utils/toolVersion'
const Cookies:any = VueCookies

router.afterEach((to, from, next) => {
  const toName = to.name?.toString().toLocaleLowerCase()
  window.scrollTo(0, 0);  
  if (toName == 'home') {
    toolVersionVerify()
  }
})

router.beforeEach((to, from, next) => {
  const toName = to.name?.toString().toLocaleLowerCase()
  const toPath = to.path?.toString().toLocaleLowerCase()
  const token = localStorage.getItem('token')
  if (token) {
    Cookies.set("token", token);
    if (store.state.lastVisitRoute) {
      next(store.state.lastVisitRoute)
      store.commit("commitRoute", "");
    } else {
      if (toName == 'login') {
        next('/home');
      } else {
        next()
      }
    }
  } else {
    if (toName == 'login' || toName == 'code') {
      next();
    } else {
      store.commit("commitRoute", to.path);
      if (toPath == "/service-agreement.html" || toPath == "/privacy-policy.html") {
        next()
      } else {
        next('/');
      }
      
    }
  }
})

// 定义特性标志
//@ts-ignore
window.__VUE_PROD_DEVTOOLS__ = false;
//@ts-ignore
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

const app = createApp(App)

app.use(ElementPlus)
app.use(store).use(router).use(VueCookies).mount('#app')
app.config.globalProperties.$DataString = DataString
